import React from "react";
import {
  ToolTip,
  ToolTipPositionType,
} from "@components/atoms/tooltip/tooltip";
import { RenderOnlyForDevelopers } from "@components/molecules/render-only-for-developers/render-only-for-developers";
import { toggleDevBorder } from "@src/cloud-connect/use-cases/toggle-dev-border";
import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import { useI18N } from "@src/language/language-context";

interface RenderOnlyForDevelopersInfoNavProps {
  tooltipPosition: ToolTipPositionType;
}

export const RenderOnlyForDevelopersInfoNav = ({
  tooltipPosition,
}: RenderOnlyForDevelopersInfoNavProps) => {
  const i18n = useI18N();

  const texts = {
    toolTipText: i18n("modules.renderOnlyForDevelopersInfo.toolTipText"),
    infoText: i18n("modules.renderOnlyForDevelopersInfo.infoText"),
  };

  const clickHandler = () => {
    toggleDevBorder();
  };

  return (
    <RenderOnlyForDevelopers>
      <ToolTip content={texts.toolTipText} position={tooltipPosition}>
        <TextButton clickHandler={clickHandler} text={texts.infoText} />
      </ToolTip>
    </RenderOnlyForDevelopers>
  );
};
